import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';

const TipFinancialDriver = () => {
  const { t } = useTranslation();
  return (
    <Tip>
      <p>
        {t('tipFinancialDriver')}
      </p>
    </Tip>
  );
};

export default TipFinancialDriver;
